import { cn } from "@/lib/utils";

type CreditsTextProps = {
  className?: string;
  credits: number | undefined;
  isVisible: boolean;
};

export default function CreditsText({
  className,
  credits,
  isVisible,
}: CreditsTextProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center transition-opacity duration-200",
        className,
        {
          "opacity-0": credits === undefined,
        },
      )}
    >
      <img
        src="/CreditIconWhite.svg"
        alt=""
        className="mr-0.5 mb-0.5 ml-3 h-3.5 w-3.5"
      />
      <span className="font-normal">{credits ? credits : "Free"}</span>
    </div>
  );
}
